import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useI18N } from '../../libraries/i18n/hook'
import PageHeading from '../components/layout/PageHeading'
import { JobOffersExplorer } from '../containers/job-offers'
import { useJobOfferFilter } from '../../libraries/search/filters'

const JobOffersPage = () => {
  const { filters, setFilters } = useJobOfferFilter()
  const { t } = useI18N()
  const navigate = useNavigate()

  React.useEffect(() => {
    setFilters({ ...filters, myJobOffers: false })
  }, [])

  return (
    <div className='pb-8'>
      <PageHeading>{t('jobs.title')}</PageHeading>
      <p className='mb-3 text-black font-light'>
        {t('jobs.description')}{' '}
        <span>
          {t('jobs.enableAlerts')}{' '}
          <a href='#' onClick={(e) => { e.preventDefault(); navigate('/onboarding/news') }} className='text-deep-green font-semibold hover:underline'>
            {t('common.here')}
          </a>{' '}
          {t('jobs.dontMissOffers')}
        </span>
      </p>
      <div className='mt-6 hidden md:block' />
      <JobOffersExplorer />
    </div>
  )
}

export default JobOffersPage
